import { useLocation } from "react-router-dom";

interface FaqItem {
  question: string;
  answer: string;
}

interface SchemaOrgProps {
  title?: string;
  description?: string;
  type?: "WebSite" | "WebPage" | "Article" | "FAQPage" | "BreadcrumbList" | "Organization";
  article?: {
    headline: string;
    description: string;
    image: string;
    datePublished: string;
    dateModified: string;
    author: string;
    category: string;
    tags: string[];
  };
  breadcrumbs?: { name: string; url: string }[];
  faqs?: FaqItem[];
}

export default function SchemaOrg({
  title = "吃瓜网51 - 全网最快免费吃瓜平台",
  description = "吃瓜网51，全网最快最全的免费吃瓜平台。每日实时更新网红黑料、明星八卦与今日大瓜，高清视频流畅观看，吃瓜群众必备神器。",
  type = "WebPage",
  article,
  breadcrumbs,
  faqs,
}: SchemaOrgProps) {
  const location = useLocation();
  const url = `http://biomicskin.cn/${location.pathname}`;

  const orgSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "吃瓜网51",
    alternateName: "51吃瓜网",
    url: "http://biomicskin.cn/",
    logo: "http://biomicskin.cn/logo.png",
    description:
      "全网最快最全的免费吃瓜爆料平台，每日实时更新明星八卦、网红黑料与今日大瓜",
    sameAs: ["http://biomicskin.cn/"],
    contactPoint: {
      "@type": "ContactPoint",
      contactType: "客户服务",
      email: "hello@biomicskin.cn",
      areaServed: "CN",
      availableLanguage: ["Chinese"],
    },
  };

  const websiteSchema = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: "吃瓜网51",
    url: "http://biomicskin.cn/",
    description:
      "全网最快最全的免费吃瓜爆料平台，每日实时更新明星八卦、网红黑料与今日大瓜",
    potentialAction: {
      "@type": "SearchAction",
      target: {
        "@type": "EntryPoint",
        urlTemplate: "http://biomicskin.cn/search?q={search_term_string}",
      },
      "query-input": "required name=search_term_string",
    },
  };

  const webpageSchema = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    name: title,
    description: description,
    url: url,
    isPartOf: {
      "@type": "WebSite",
      name: "吃瓜网51",
      url: "http://biomicskin.cn/",
    },
    dateModified: "2026-07-02",
    inLanguage: "zh-CN",
  };

  const articleSchema = article
    ? {
        "@context": "https://schema.org",
        "@type": "Article",
        headline: article.headline,
        description: article.description,
        image: article.image,
        datePublished: article.datePublished,
        dateModified: article.dateModified,
        author: {
          "@type": "Person",
          name: article.author,
        },
        publisher: {
          "@type": "Organization",
          name: "吃瓜网51",
          logo: {
            "@type": "ImageObject",
            url: "http://biomicskin.cn/logo.png",
          },
        },
        url: url,
        articleSection: article.category,
        keywords: article.tags.join(", "),
        inLanguage: "zh-CN",
      }
    : null;

  const breadcrumbSchema = breadcrumbs
    ? {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        itemListElement: breadcrumbs.map((item, index) => ({
          "@type": "ListItem",
          position: index + 1,
          name: item.name,
          item: item.url,
        })),
      }
    : null;

  const faqSchema = faqs && faqs.length > 0
    ? {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: faqs.map((faq) => ({
          "@type": "Question",
          name: faq.question,
          acceptedAnswer: {
            "@type": "Answer",
            text: faq.answer,
          },
        })),
      }
    : null;

  const schemas: Record<string, unknown> = {
    Organization: orgSchema,
    WebSite: websiteSchema,
    WebPage: webpageSchema,
    Article: articleSchema,
    BreadcrumbList: breadcrumbSchema,
    FAQPage: faqSchema,
  };

  const selectedSchema = schemas[type];
  if (!selectedSchema) return null;

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: JSON.stringify(selectedSchema),
      }}
    />
  );
}
